import { HttpError } from "react-admin";
import { redirectForAuthorization } from "../auth/authProvider";

export const httpClientJwt = async (url: string, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }

  if (options.method && options.method !== "GET") {
    options.headers.set("Content-Type", "application/json");
  }

  const token = localStorage.getItem("jwttoken");
  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }

  try {
    const response = await fetch(url, options);
    const text = await response.text();

    let json;
    try {
      json = JSON.parse(text);
    } catch (e) {
      console.error("Not JSON, no big deal");
    }

    if (response.status < 200 || response.status >= 300) {
      if (response.status === 401) {
        // При 401 редирект на авторизацию
        redirectForAuthorization();
      } else if (response.status === 403) {
        // При 403 просто вывод ошибки
        console.error(
          "Access forbidden: You do not have the necessary permissions."
        );
      }
      throw new HttpError(
        (json && json.message) || response.statusText,
        response.status,
        json
      );
    }

    return {
      status: response.status,
      headers: response.headers,
      body: text,
      json,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};
